module.exports = __webpack_public_path__ + "static/media/launay5Paysage.8ab0190b.JPG";